export default "__VITE_ASSET__BOpmeGIp__"